// owl custom element for initilization
class OwlCarouselElement extends HTMLElement {
  constructor() {
    super();
    this.owlInstance = null;
    this.resizeHandler = null;
  }

  connectedCallback() {
    this.originalItems = this.getCarousel()?.children.length || 0;
    this.init();
    this.setupResizeListener();
  }

  disconnectedCallback() {
    if (this.resizeHandler) {
      window.removeEventListener("resize", this.resizeHandler);
    }
    this.destroyOwl();
  }

  setupResizeListener() {
    this.resizeHandler = () => this.updateOwlState();
    window.addEventListener("resize", this.resizeHandler);
  }

  init() {
    this.updateOwlState();
  }

  getCarousel() {
    return this.querySelector(".owl-carousel");
  }

  getResponsiveConfig() {
    const attr = this.getAttribute("data-responsive");
    if (!attr) return {};
    try {
      return JSON.parse(attr);
    } catch (e) {
      console.warn("Invalid data-responsive JSON", e);
      return {};
    }
  }

  getCurrentItemsCount() {
    const responsive = this.getResponsiveConfig();
    const width = document.documentElement.clientWidth;
    let items = 1;

    Object.keys(responsive).forEach(bp => {
      if (width >= Number(bp) && responsive[bp].items) {
        items = responsive[bp].items;
      }
    });

    return items;
  }

  updateOwlState() {
    const carousel = this.getCarousel();
    if (!carousel) return;

    const totalItems = this.originalItems;
    const visibleItems = this.getCurrentItemsCount();

    if (totalItems > visibleItems) {
      if (!this.owlInstance) this.enableOwl();
    } else {
      if (this.owlInstance) this.destroyOwl();
    }
  }

  enableOwl() {
    if (this.owlInstance) return;

    const $carousel = $(this.getCarousel());

    const loopEnabled = this.getAttribute("data-loop") === "true";
    const autoplayEnabled = this.getAttribute("data-autoplay") === "true";

    const options = {
      loop: loopEnabled,
      rewind: !loopEnabled && this.getAttribute("data-rewind") === "true",
      dots: this.getAttribute("data-dots") === "true",
      nav: this.getAttribute("data-nav") === "true",
      autoplay: autoplayEnabled,
      autoWidth: false,
      center: this.getAttribute("data-center") === "true",
      autoplayTimeout: Number(
        this.getAttribute("data-autoplay-timeout") || 6000
      ),

      responsive: this.getResponsiveConfig()
    };
    if (this.hasAttribute("data-autoplay-speed")) {
      options.autoplaySpeed = Number(this.getAttribute("data-autoplay-speed"));
    }

    if (this.hasAttribute("data-smart-speed")) {
      options.smartSpeed = Number(this.getAttribute("data-smart-speed"));
    }

    if (this.hasAttribute("data-slide-transition")) {
      options.slideTransition = this.getAttribute("data-slide-transition");
    }

    if (this.hasAttribute("data-autoplay-timeout")) {
      options.autoplayTimeout = Number(
        this.getAttribute("data-autoplay-timeout")
      );
    }
    $carousel.owlCarousel(options);
    this.owlInstance = $carousel;
  }

  setupResizeListener() {
    let resizeTimeout;
    this.resizeHandler = () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        this.updateOwlState();
      }, 200);
    };
    window.addEventListener("resize", this.resizeHandler);
  }

  destroyOwl() {
    if (!this.owlInstance) return;

    this.owlInstance.trigger("destroy.owl.carousel");
    this.owlInstance.find(".owl-stage-outer").children().unwrap();
    this.owlInstance.removeClass("owl-loaded");
    this.owlInstance = null;
  }
}

customElements.define("custom-owlcarousel", OwlCarouselElement);
